
import { UserProfile } from './types';

// Tagging System Utilities
// Moved here to avoid circular dependencies in firebase.ts

export const parseMentions = (text: string, allUsers: UserProfile[]): { username: string; uid: string; }[] => {
    if (!text) return [];
    const mentionRegex = /@([a-zA-Z0-9_]+)/g;
    const mentions = text.match(mentionRegex) || [];
    const uniqueUsernames = [...new Set(mentions.map(m => m.substring(1).toLowerCase()))];
    
    return uniqueUsernames
        .map(username => {
            const user = allUsers.find(u => u.displayName.toLowerCase() === username);
            return user ? { username: user.displayName, uid: user.uid } : null;
        })
        .filter((user): user is { username: string; uid: string; } => user !== null);
};

export const parseHashtags = (text: string): string[] => {
    if (!text) return [];
    const hashtagRegex = /#([a-zA-Z0-9_]+)/g;
    const hashtags = text.match(hashtagRegex) || [];
    return [...new Set(hashtags.map(h => h.toLowerCase()))];
};

export const isUserOnline = (user: UserProfile | undefined): boolean => {
    if (!user || !user.isOnline || user.appearOffline) return false;
    if (!user.lastSeen) return false;
    
    try {
        let lastSeenTime: number;
        if (typeof user.lastSeen.toMillis === 'function') {
            lastSeenTime = user.lastSeen.toMillis();
        } else if (user.lastSeen.seconds !== undefined) {
            // Handle plain object case (e.g. from serialization)
            lastSeenTime = user.lastSeen.seconds * 1000;
        } else {
            return false;
        }
        
        const now = Date.now();
        // Check if lastSeen is within the last 5 minutes (300,000 ms)
        return (now - lastSeenTime) < 300000;
    } catch (e) {
        return false;
    }
};
